export const FooterUrls: Record<string, string> = {
    lystIndex: "https://www.lyst.com/data/the-lyst-index",
    lystNews: "https://www.lyst.com/news/",
    makingLyst: "https://making.lyst.com/",
    surveyTermsAndConditions: "/help/survey-terms-and-conditions/",
};
